import { EncryptStorage } from "encrypt-storage";

// noble engine keeps the API synchronous, matching plain sessionStorage usage across the app.
const secureSessionStorage = EncryptStorage.create(
  process.env.VITE_SESSION_STORAGE_SECRET_KEY || "iform-designer-session-secret-key",
  {
    engine: "noble",
    storageType: "sessionStorage",
    prefix: "@iform",
  }
);

export default secureSessionStorage;